@if (usuarioAutenticado()) {
  @if (!editMode()) {
    <div class="flex flex-col gap-6">
      @if (fotosView().length) {
        <div class="flex flex-col gap-3">
          <div class="font-semibold text-xl border-b-2 border-[var(--color-primary)]">Fotos</div>
          <div class="grid md:grid-cols-5 gap-2">
            @for (item of fotosView(); track item.idArquivo) {
              <div class="flex flex-col gap-1 group/foto">
                <div
                  class="relative aspect-square rounded-[5px] shadow-md bg-gray-100 flex items-center justify-center group overflow-hidden"
                  [class.bg-cover]="item.status === 'loaded'"
                  [class.bg-center]="item.status === 'loaded'"
                  [style.background-image]="item.status === 'loaded' ? 'url(' + item.urlImagem + ')' : null">
                  @if (item.status === 'loading') {
                    <i class="pi pi-spin pi-spinner text-[#99a1af]"></i>
                  } @else if (item.status === 'error') {
                    <app-icon-image-bold color="#99a1af"/>
                  }
                  <div
                    class="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors">
                    <button
                      type="button"
                      pTooltip="Download"
                      tooltipStyleClass="tooltip-white"
                      class="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity text-white cursor-pointer"
                      (click)="onDownloadAnexo(item)">
                      <app-icon-bold-document-download [size]="iconSize()" color="currentColor"/>
                    </button>
                  </div>
                </div>
                <div class="text-xs text-center text-[#101010] font-medium leading-tight">
                  <p class="truncate" [pTooltip]="item.nomeOriginal"
                     tooltipStyleClass="tooltip-white">{{ item.nomeOriginal }}</p>
                  <p>{{ getFormattedFileSize(item.tamanho) }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (documentosView().length) {
        <div class="flex flex-col gap-3">
          <div class="font-semibold text-xl border-b-2 border-[var(--color-primary)]">Documentos</div>
          <p-table [value]="documentosView()">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" style="width: 30%">Tipo do Documento</th>
                <th scope="col">Arquivo</th>
                <th scope="col">Tamanho</th>
                <th scope="col">
                  <div class="flex justify-center items-center">Ações</div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td style="max-width: 0; overflow: hidden;">
                  <span
                    class="block truncate"
                    [pTooltip]="getTipoDocumentoLabel(item)"
                    tooltipPosition="top"
                    tooltipStyleClass="tooltip-white"
                  >{{ getTipoDocumentoLabel(item) }}</span>
                </td>
                <td>{{ item.nomeOriginal || '-' }}</td>
                <td>{{ getFormattedFileSize(item.tamanho) }}</td>
                <td>
                  <div class="flex justify-center">
                    <p-button styleClass="btn-icon" (onClick)="onDownloadAnexo(item)"
                        (keydown.enter)="$event.preventDefault(); onDownloadAnexo(item)"
                        (keydown.space)="$event.preventDefault(); onDownloadAnexo(item)" pTooltip="Download"
                              tooltipPosition="left" tooltipStyleClass="tooltip-white">
                      <app-icon-bold-document-download [size]="iconSize()" color="#001E39"/>
                    </p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
  } @else {
    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-3">
        <div class="font-semibold text-xl border-b-2 border-[var(--color-primary)]">Fotos</div>
        <div class="flex flex-col gap-4">
          <p-fileupload
            (onSelect)="onSelectFoto($event)"
            [multiple]="false"
            [showCancelButton]="false"
            [disabled]="fotosAtingiramLimite() || !editMode()"
            [showUploadButton]="false"
            chooseLabel="Selecione"
            chooseStyleClass="btn-red shrink-0"
            class="w-full"
            name="fileInput"
            styleClass="!flex !flex-row !items-center !text-[#858796]">
            <ng-template pTemplate="chooseicon">
              <app-icon-bold-document-upload [size]="iconSize()" color="currentColor"/>
            </ng-template>
            <ng-template pTemplate="content">
              @if (!fotoFileTooLarge && !fotoFileInvalidExtension) {
                <div class="text-sm min-w-0 ">
                  Formatos permitidos: JPG, JPEG, PNG ou BMP - Limite máximo
                  de {{ tipoFoto()?.quantidadeMaxima ?? 5 }} imagens
                </div>
              } @else if (fotoFileTooLarge) {
                <span
                  class="text-sm text-primary min-w-0 ">Tamanho do arquivo não permitido. Somente arquivos até {{ getFotoFormattedMaxSize() }}</span>
              } @else {
                <span class="text-sm text-primary min-w-0 ">Formatos permitidos: JPG, JPEG, PNG ou BMP</span>
              }
            </ng-template>
            <ng-template pTemplate="file"></ng-template>
          </p-fileupload>

          <div class="grid md:grid-cols-5 gap-2">
            @for (item of fotosEnviadas(); track item.id) {
              <div class="flex flex-col gap-1 group/foto">
                <div
                  class="relative aspect-square rounded-[5px] shadow-md bg-cover bg-center group overflow-hidden"
                  [style.background-image]="'url(' + (item.urlImagem || getFileObjectUrl(item.file)) + ')'"
                >
                  @if (item.status === 'uploading') {
                    <div class="absolute inset-0 flex items-center justify-center bg-black/30">
                      <i class="pi pi-spin pi-spinner text-white text-sm"></i>
                    </div>
                  } @else if (editMode()) {
                    <div class="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors">
                      <button
                        type="button"
                        pTooltip="Excluir"
                        tooltipStyleClass="tooltip-white"
                        class="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity text-white cursor-pointer"
                        (click)="onRemoverFoto(item.id)">
                        <app-icon-close-square color="currentColor"/>
                      </button>
                    </div>
                  }
                </div>
                <div class="text-xs text-center text-[#101010] font-medium leading-tight">
                  <p class="truncate" [pTooltip]="item.file.name"
                     tooltipStyleClass="tooltip-white">{{ item.file.name }}</p>
                  <p>{{ getFormattedFileSize(item.anexo?.tamanho ?? item.file.size) }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <div class="font-semibold text-xl border-b-2 border-[var(--color-primary)]">Documentos</div>
        <form [formGroup]="form" class="flex flex-col gap-4">
          <div class="flex flex-col">
            <label [for]="fieldId + '-tipo-documento'">Tipo do Documento</label>
            <p-select
              [inputId]="fieldId + '-tipo-documento'"
              [options]="tiposDocumento()"
              optionLabel="nome"
              fluid
              appendTo="body"
              filterBy="nome"
              [filter]="true"
              placeholder="Selecione"
              formControlName="tipoDocumento"/>
          </div>

          @if (tipoDocumentoSelecionado?.nome === 'Outros') {
            <div class="flex flex-col">
              <label [for]="fieldId + '-descricao-arquivo'">Descrição do Arquivo<span class="required">*</span></label>
              <input pInputText
                     [id]="fieldId + '-descricao-arquivo'"
                     fluid
                     maxlength="50"
                     placeholder="Digite"
                     [readonly]="!editMode()"
                     formControlName="descricaoArquivo"/>
              @if (isFormControlInvalid("descricaoArquivo")) {
                <span class="required text-sm">Campo obrigatório.</span>
              }
            </div>
          }

          @if (editMode()) {
            <p-fileupload
              (onSelect)="onSelectDocumento($event)"
              [multiple]="false"
              [showCancelButton]="false"
              [disabled]="!tipoDocumentoSelecionado || tipoDocumentoSelecionadoAtingiuLimite() || form.invalid || uploadEmAndamento()"
              [showUploadButton]="false"
              chooseLabel="Selecione"
              chooseStyleClass="btn-red shrink-0"
              class="w-full"
              name="fileInput"
              styleClass="!flex !flex-row !items-center !text-[#858796]">
              <ng-template pTemplate="chooseicon">
                <app-icon-bold-document-upload [size]="iconSize()" color="currentColor"/>
              </ng-template>
              <ng-template pTemplate="content">
                @if (tipoDocumentoSelecionadoAtingiuLimite()) {
                  <span
                    class="text-sm text-primary">Limite de anexos atingido para {{ tipoDocumentoSelecionado?.nome }}</span>
                } @else if (!docFileTooLarge && !docFileInvalidExtension) {
                  <div class="text-smz ">Formatos permitidos: {{ getDocFormattedExtensions() }}</div>
                } @else if (docFileTooLarge) {
                  <span
                    class="text-sm text-primary  ">Tamanho de arquivo não permitido. Somente arquivos de até {{ getDocFormattedMaxSize() }}</span>
                } @else {
                  <span
                    class="text-sm text-primary  ">Formatos permitidos: {{ getDocFormattedExtensions() }}</span>
                }
              </ng-template>
              <ng-template pTemplate="file"></ng-template>
            </p-fileupload>
          }

          @if (documentosEnviados().length > 0) {
            <p-table [value]="documentosEnviados()">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col" style="width: 30%">Tipo do Documento</th>
                  <th scope="col">Anexo</th>
                  <th scope="col">Tamanho</th>
                  <th scope="col">Ações</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td style="max-width: 0; overflow: hidden;">
                    <span
                      class="block truncate"
                      [pTooltip]="getTipoDocumentoLabel(item)"
                      tooltipPosition="top"
                      tooltipStyleClass="tooltip-white"
                    >{{ getTipoDocumentoLabel(item) }}</span>
                  </td>
                  <td>
                    <div class="flex items-center gap-2">
                      @if (item.status === 'uploading') {
                        <i class="pi pi-spin pi-spinner text-[#858796]"></i>
                      } @else if (item.status === 'error') {
                        <i class="pi pi-times-circle text-red-500"></i>
                      }
                      <span>{{ item.file.name }}</span>
                    </div>
                  </td>
                  <td>{{ getFormattedFileSize(item.anexo?.tamanho ?? item.file.size) }}</td>
                  <td>
                    <div class="flex iems-center justify-center gap-1">
                      <p-button styleClass="btn-icon" (onClick)="onDownloadDocumento(item)"
                          (keydown.enter)="$event.preventDefault(); onDownloadDocumento(item)"
                          (keydown.space)="$event.preventDefault(); onDownloadDocumento(item)" pTooltip="Download"
                                tooltipPosition="left" tooltipStyleClass="tooltip-white">
                        <app-icon-bold-document-download [size]="iconSize()" color="#001E39"/>
                      </p-button>
                      @if (editMode()) {
                        <p-button styleClass="btn-icon" (onClick)="onRemoverDocumento(item.id)"
                            (keydown.enter)="$event.preventDefault(); onRemoverDocumento(item.id)"
                            (keydown.space)="$event.preventDefault(); onRemoverDocumento(item.id)" pTooltip="Excluir"
                                  tooltipPosition="left" tooltipStyleClass="tooltip-white"
                                  [disabled]="uploadEmAndamento()">
                          <app-icon-bold-trash [size]="iconSize()" color="#BD2130"/>
                        </p-button>
                      }
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          }
        </form>
      </div>

    </div>

  }

}
